import React from 'react';
import { motion } from 'framer-motion';

const DownloadFormatModal = ({
  showModal,
  onClose,
  onSelectFormat,
  downloading = false
}) => {
  if (!showModal) return null;

  return (
    <div className="campaign-download-modal-overlay" onClick={onClose}>
      <motion.div
        className="campaign-download-modal download-format-modal"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} className="close-modal-btn" type="button" aria-label="Close">
          ×
        </button>
        <h3>Choose download format</h3>
        <p className="modal-subtitle">
          Select how you want the campaign file to be downloaded.
        </p>
        <div className="modal-actions download-format-actions">
          <button
            type="button"
            onClick={() => onSelectFormat('default')}
            className="download-format-btn download-only-btn"
            disabled={downloading}
            style={{
              opacity: downloading ? 0.6 : 1,
              cursor: downloading ? 'not-allowed' : 'pointer'
            }}
          >
            {downloading ? (
              <>
                <span
                  className="loading-spinner"
                  style={{
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginRight: '8px'
                  }}
                  aria-hidden
                />
                Downloading...
              </>
            ) : (
              'Download only'
            )}
          </button>
          <button
            type="button"
            onClick={() => onSelectFormat('limechat')}
            className="download-format-btn download-limechat-btn"
            disabled={downloading}
            style={{
              opacity: downloading ? 0.6 : 1,
              cursor: downloading ? 'not-allowed' : 'pointer'
            }}
          >
            Download for Limechat
          </button>
          <button
            type="button"
            onClick={() => onSelectFormat('email')}
            className="download-format-btn download-email-btn"
            disabled={downloading}
            style={{
              opacity: downloading ? 0.6 : 1,
              cursor: downloading ? 'not-allowed' : 'pointer'
            }}
          >
            Download for email
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default DownloadFormatModal;
